module.exports = __webpack_public_path__ + "static/media/alligned.325c601e.jpg";